import Loader from './assets/loader.gif';

// import Backdrop from '@material-ui/core/Backdrop';

/**
 * Componente responsavel pelo carregamento do loader
 * @param {*} open responsavel por abrir o loader 
 * @returns loader.gif
 */
export const ReportRestrictionAreasLoader = ({ open, ...props }) => {
  return (    
      <img src={Loader} alt="Carregando..." style={{ width: '300px' }} />    
  );
};

export default ReportRestrictionAreasLoader;
